import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { jobDetailsBatchConfig } from './config';

const JobDetailsBatchStack = createStackNavigator();

const JobDetailsBatchNavigator = () => {
  return (
    <JobDetailsBatchStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {jobDetailsBatchConfig.map(({ Component, name }) => (
        <JobDetailsBatchStack.Screen key={name} name={name} component={Component} />
      ))}
    </JobDetailsBatchStack.Navigator>
  );
};

export { JobDetailsBatchNavigator };
